import { Injectable } from '@angular/core';
import { EntityType, JkEntityV2, jkLib, dateFormatter, } from 'jk-service';
import { Jcktl } from '../entity/Jcktl-angular';


@Injectable({
  providedIn: 'root'
})
export class JcktlServicePkg extends JkEntityV2 {


  constructor() {
    super();
    this.linkMasterFields = '';
    this.defaultItem = new Jcktl();
    this.entityType.type = EntityType.master;
    this.columnLabel = {
      COMPANY: '公司代號', CREATOR: '建檔者代號', USR_GROUP: '群組', CREATE_DATE: '建檔日期', MODIFIER: '修改者代號', MODI_DATE: '修改日期', FLAG: '更新次數',
      TL001: '單號', TL002: '日期', TL003: '問卦者', TL004: '時間', TL005: '分類', TL006: '問題', TL007: '回答', TL008: '上卦', TL009: '下卦', TL010: '變爻', TL011: '年齡', TL012: '性別', TL013: 'DateTime'
    };

    this.fieldNames = 'TL001,TL002,TL003,TL004,TL005,TL006,TL007,TL008,TL009,TL010,TL011,TL012,TL013';
    this.fieldLengths = { TL001: 20, TL002: 8, TL003: 10, TL004: 1, TL005: 20, TL006: 0, TL007: 0, TL008: 6, TL009: 6, TL010: 6, TL011: 6, TL012: 2, TL013: 0 };
    this.columnDefs = [
      { field: "TL008", headerName: "上卦", headerTooltip: "", width: 155, cellDataType: "number", },
      { field: "TL013", headerName: "DateTime", headerTooltip: "", width: 155, cellDataType: "date", valueFormatter: (p: any) => { return jkLib.datetimeFormatter(p.value) }, },
      { field: "TL012", headerName: "性別", headerTooltip: "", width: 155, cellDataType: "text", },
      { field: "TL011", headerName: "年齡", headerTooltip: "", width: 155, cellDataType: "number", },
      { field: "TL010", headerName: "變爻", headerTooltip: "", width: 155, cellDataType: "number", },
      { field: "TL009", headerName: "下卦", headerTooltip: "", width: 155, cellDataType: "number", },
      { field: "TL001", headerName: "單號", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "TL007", headerName: "回答", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "TL006", headerName: "問題", headerTooltip: "", width: 250, cellDataType: "text", },
      { field: "TL005", headerName: "分類", headerTooltip: "", width: 230, cellDataType: "text", },
      { field: "TL004", headerName: "時間", headerTooltip: "", width: 155, cellDataType: "text", },
      { field: "TL003", headerName: "問卦者", headerTooltip: "", width: 155, cellDataType: "text", },
      { field: "TL002", headerName: "日期", headerTooltip: "", width: 155, cellDataType: "text", valueFormatter: dateFormatter, },
    ];
    this.columnDefsVir = [
    ];
    this.tableName = 'JCKTL';
    this.isSys = false;
    this.sqlSelect = `SELECT JCKTL.*  FROM JCKTL`;
    this.sqlWhereDefault = `/*WHERE*/ WHERE 1=1`;
    this.sqlOrderDefault = ` ORDER BY TL001`;
    this.keyFields = ['TL001'];
    this.url = '/db/crud';
    this.rememberFields = [];
    this.requiredFields = ['TL001'];
    this.seqField = '';
    this.seqFieldLength = 0;
  }
  override async validateItem(item: Jcktl): Promise<boolean> {
    let bool = await super.validateItem(item);
    return bool;
  }

  override async newRecord(newItem: Jcktl): Promise<Jcktl> {
    await super.newRecord(newItem);
    return newItem;
  }




}

// 客製開始====================================================
